import React, { useState, useRef, useEffect, useCallback } from "react";
import { ApiService } from "../../Component/services/apiServices";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import Skeleton from "react-loading-skeleton";
import moment from 'moment';
import Footer from "../../Component/Footer"
import Header from "../../Component/Header"
import AccountHeader from "../../Component/Header/account_header";

const Stores = () => {
    const [storesData, setStoresData] = useState([]);
    const [isLoading, setisLoading] = useState(true)
    const didMountRef = useRef(true);
    
    const getStores = useCallback(() => {
        ApiService.fetchData('getourstoredata').then((res) => {
            if (res.status === 'success') {
                setStoresData(res.resStoreData)
                setisLoading(false)
            } else {
                setisLoading(false)
            }
        }).catch(() => {
            setisLoading(false)
        })
    }, []);

    useEffect(() => {
        if (didMountRef.current) {
            getStores()
        }
        didMountRef.current = false;
    }, [getStores]);

    return (
        <>
            <AccountHeader heading={'Stores'}></AccountHeader>
            <div id="appCapsule">
            {isLoading ?
                Array(3)
                    .fill(0)
                    .map((_, index) => (
                        <React.Fragment key={index}>
                            <section className="section-gap-md">
                                <div className="container">
                                    <div className={`row align-items-center justify-content-center `}>
                                        <div className="col-lg-6">
                                            <div className="storeGallerybox">
                                                <Skeleton height={500} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <h2 className="mb-20">
                                                <Skeleton width={200} />
                                            </h2>
                                            <ul className="storeContect">
                                                <li>
                                                    <Skeleton width={300} height={20} />
                                                </li>
                                                <li>
                                                    <Skeleton width={250} height={20} />
                                                </li>
                                                <li>
                                                    <Skeleton width={200} height={20} />
                                                </li>
                                                <li>
                                                    <Skeleton width={150} height={20} />
                                                </li>
                                            </ul>
                                            <div className="storeMap">
                                                <Skeleton height={150} />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>
                        </React.Fragment>
                    ))
                :
                storesData && storesData.length > 0 &&
                storesData.map((item, index) => {
                    const galleryimage = [item?.store_profile_image];
                    if (item.gallery) {
                        item.gallery.forEach((value) => {
                            galleryimage.push(value.gallery_image);
                        });
                    }
                    return (
                        <React.Fragment key={index}>
                            <section className="section-gap-md">
                                <div className="container">
                                    <div className={`row align-items-center justify-content-center`}>
                                        <div className="col-lg-6">
                                            <div className="storeGallerybox">
                                                <Swiper
                                                    spaceBetween={0}
                                                    centeredSlides={true}
                                                    autoplay={{
                                                        delay: 2500,
                                                        disableOnInteraction: false,
                                                    }}
                                                    pagination={{
                                                        clickable: true,
                                                    }}
                                                    navigation={false}
                                                    modules={[Autoplay, Pagination, Navigation]}
                                                    className="mySwiper"
                                                >
                                                    {galleryimage.map((image, index) => (
                                                        <SwiperSlide key={index}>
                                                            <div>
                                                                <img
                                                                    src={image}
                                                                    alt="Daadi's Kitchen"
                                                                />
                                                            </div>
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <h2 className="mb-20">{item?.store_name}</h2>
                                            <ul className="storeContect">
                                                {item?.store_address && (
                                                    <li>
                                                        <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                                            item?.store_address
                                                        )}`} target="_blank" rel="noopener noreferrer">
                                                            <i className="ri-map-pin-line"></i>
                                                            {item?.store_address}
                                                        </a>
                                                    </li>
                                                )}
                                                {item?.store_email && (
                                                    <li>
                                                        <a href={`mailto:${item?.store_email}`} target="_blank" rel="noopener noreferrer">
                                                            <i className="ri-mail-line" ></i>
                                                            {item?.store_email}
                                                        </a>
                                                    </li>
                                                )}
                                                {item?.store_mobile && (
                                                    <li>
                                                        <a href={`tel:${item?.store_mobile}`} target="_blank" rel="noopener noreferrer">
                                                            <i className="ri-phone-line"></i>
                                                            {item?.store_mobile}
                                                        </a>
                                                    </li>
                                                )}
                                                {(item?.store_open_time || item?.store_close_time) && (
                                                    <li>
                                                        <a href="javascript:void(0)">
                                                            <i className="ri-time-line"></i>
                                                            {item.store_id === 20 ? '24 X 7' : moment(item?.store_open_time, "HH:mm:ss").format("h:mm A") + '-' + moment(item?.store_close_time, "HH:mm:ss").format("h:mm A")}
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                            {item?.store_address && <div className="storeMap">
                                                <iframe
                                                    src={`https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(
                                                        item?.store_address
                                                    )}&key=AIzaSyAE7oxhbgUxiIzikhCeN6TB6UUe1frQnZs`}
                                                    width="100%"
                                                    allowFullScreen=""
                                                    loading="lazy"
                                                    title={`Map of ${item?.store_name}`}
                                                ></iframe>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </React.Fragment>
                    );
                })} 


            </div>
           
        </>
    )
}

export default Stores